module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "UpdateDateControl",
    staticStyle: {
      "width": "140px",
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-family": "HelveticaNeue"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "mouseenter": function($event) {
        _vm.updateToggle(true, $event)
      },
      "mouseleave": function($event) {
        _vm.updateToggle(false, $event)
      }
    }
  }, [_vm._v("\n        LastUpdateTime\n    ")]), _vm._v(" "), _c('div', {
    ref: "divLastUpdateTime",
    staticClass: "LastUpdateContainer",
    class: {
      hidden: this.IsShowUpdate === false
    }
  }, [_c('div', {
    staticClass: "UpdateTime"
  }, _vm._l((_vm.UpdateDateList), function(dw) {
    return _c('div', {
      staticClass: "UpdateTimeSpan"
    }, [_vm._v("\n                " + _vm._s(dw.UpdateDate) + "\n                "), _c('br'), _vm._v(_vm._s(dw.UpdateTime) + "\n            ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db8ea35a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateDate.vue
// module id = 487
// module chunks = 2